import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { clearToken } from 'store'; // 根据实际路径调整
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

// 注意：React 的环境变量必须以 REACT_APP_ 开头才能被识别
const getBaseURL = () => {
  // 优先使用 .env 文件中的配置
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  console.log('process.env.NODE_ENV',process.env.NODE_ENV);
  
  // 开发环境默认使用测试地址
  if (process.env.NODE_ENV === 'development') {
    return 'https://rz.lhh.qmjsfw.com/ms-union-attestation/';
  }
  // 生产环境默认使用正式地址
  return 'https://www.csc-csgf.com/ms-union-attestation/';
};

// 4. 创建 apiClient
const apiClient = axios.create({
  // baseURL: 'https://www.csc-csgf.com/ms-union-attestation/', // 删除这行写死的
  baseURL: getBaseURL(), // 使用动态获取的 URL
});

// 创建一个 Hook 来使用 apiClient
export const useApiClient = () => {
  const token = useSelector((state) => state.auth.token); // 从 Redux store 获取 token
  const dispatch = useDispatch();
  const navigate = useNavigate();

  apiClient.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers['Authorization'] = token;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  apiClient.interceptors.response.use(
    (res) => {
      if (res.data.success === false) {
        message.error(res.data.errMessage);
        return Promise.reject(new Error(res.data.errMessage));
      }
      return res.data.data;
    },
    (error) => {
      console.log(error);

      if (error.response && error.response.status === 401) {
        dispatch(clearToken());
        navigate('/login');
      }
      return Promise.reject(error);
    }
  );
  const requestToken = (url, method = 'get', submitData) => {
    return apiClient.request({
      url,
      method,
      headers: {
        Authorization: token,
      },
      [method.toLowerCase() === 'get' ? 'params' : 'data']: submitData,
    });
  };
  return { apiClient, requestToken };
};



export const request = (url, method, submitData) => {
  return apiClient.request({
    url,
    method,
    headers: {
      'Content-Type': 'application/json',  // 强制将数据作为 JSON 传递
    },
    [method.toLowerCase() === 'get' ? 'params' : 'data']: submitData,

  });
};

export default useApiClient;
